import { render, staticRenderFns } from "./custom-search-type-1.vue?vue&type=template&id=87ef704e&scoped=true&"
import script from "./custom-search-type-1.vue?vue&type=script&lang=js&"
export * from "./custom-search-type-1.vue?vue&type=script&lang=js&"
import style0 from "./custom-search-type-1.vue?vue&type=style&index=0&id=87ef704e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ef704e",
  null
  
)

export default component.exports